// extracted by mini-css-extract-plugin
export default {"container":"backButton_container__0WUej","text":"backButton_text__Nf+x1"};